import { Hidden } from '@material-ui/core';
import React from 'react';
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
import LaunchIcon from '@material-ui/icons/Launch';
import { buttonStyles } from '../../../../global/constants/theme/styles/components/buttonstyles';
import { SearchProps } from '../../models/arc-epi-props';
import { BillingAccount } from './billing-accounts-models';
import { getCurrencyFormat } from '../../../../global/helpers/format-helpers';
import { ApiEndpoint } from '../../../../global/constants/api-endpoints';
import { downloadFileFromApi } from '../../../../global/helpers/file-helpers';
import { SearchExternalLink } from '../../../../global/components/external-link-modal';


interface BillingAccountProps {
	item: BillingAccount;
	onSetBillingAccount: () => void;
	settings: SearchProps;
	billingAccountUrl: string;
	bearerToken: string;
	externalLinkState: any;
}

export const BillingAccountView = (props: BillingAccountProps) => {
	const { item, billingAccountUrl, bearerToken, externalLinkState } = props;

	const buttonClasses = buttonStyles();

	const accountHistoryUrl = billingAccountUrl?.replace(':account', item.account_number);

	const downloadInvoices = (pdf: boolean) => {
		const fileName = pdf ? 'invoices.pdf' : 'invoices.xls';
		const requestUrl = `${ApiEndpoint.mlps}/document/billing_current/statement_${pdf ? 'pdf' : 'xlsx'}/account/${item.account_number}`;

		downloadFileFromApi(requestUrl, bearerToken, fileName);
	};

	return (
		<div className='sort-table-row'>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.accountNumberLabel}</p>
				</Hidden>
				<button className={buttonClasses.linkButton} type='button' onClick={props.onSetBillingAccount}>{item?.account_number}</button>
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.accountNameLabel}</p>
				</Hidden>
				{item?.account_name}
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.accountCityLabel}</p>
				</Hidden>
				{item?.billing_city}
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.enrolledMembersLabel}</p>
				</Hidden>
				{item?.covered_person_count}
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.enrolledMembersLabel}</p>
				</Hidden>
				{getCurrencyFormat(parseFloat(item?.current_amount_due))}
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.billingHistoryLabel}</p>
				</Hidden>
				<SearchExternalLink linkUrl={accountHistoryUrl} linkText={<>View <LaunchIcon /></>} {...externalLinkState} />
			</div>
			<div className='sort-table-row-cell'>
				<Hidden smUp>
					<p className='input-label'>{props.settings?.invoicesLabel}</p>
				</Hidden>
				<div className='icon-button-cell'>
					<button
						type='button'
						className={buttonClasses.linkButton}
						onClick={() => downloadInvoices(true)}>
						<PictureAsPdfIcon />
					</button>
					<button
						type='button'
						className={buttonClasses.linkButton}
						onClick={() => downloadInvoices(false)}>
						<svg className='' aria-hidden='true' focusable='false'>
							<use xmlnsXlink='http://www.w3.org/2000/xlink' xlinkHref='#excel-icon' />

						</svg>
					</button>
				</div>
			</div>

		</div>
	);

};